import React from 'react';
import './App.css';
import Routes from './router/Routes';

function App() {
  React.useEffect(() => {
    const stored = localStorage.getItem('theme');
    const nextIsDark = stored ? stored === 'dark' : true;
    document.body.dataset.theme = nextIsDark ? 'dark' : 'light';
  }, []);

  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
